<template>
    <div class="float-contact">
        <div style="cursor: pointer;"><img src="/static/img/index/contact.png" alt="" width="70" height="180"/></div>
        <div style="cursor: pointer;">
            <a href="/aboutUs?#sectionForm"><img src="/static/img/index/try.png" alt="" width="70" height="70"/></a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "contactUs",
        data() {
            return {}
        },
        components: {},
        watch: {},
        mounted() {

        },
        created() {

        },
        methods: {}
    }
</script>

<style scoped>
.float-contact{
    position: fixed;
    width: 70px;height: auto;
    bottom:300px;
    left:50%;
    margin-left: 600px;
}
</style>
